/**
 * @fileoverview We use canvas to measure text, but that isn't
 * supported when unit testing. This stub fills the gaps.
 */

const DEFAULT_CHAR_WIDTH = 10

const STUB = {
  measureText: text => ({
    width: `${text}`.length * DEFAULT_CHAR_WIDTH
  })
}

/**
 * Returns the minimal interface required for HTML5 canvas based text
 * measurement
 */
export default function getContext() {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  if (ctx == null) {
    return STUB
  }

  return ctx
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/text/get-context.js